"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _clsx3 = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["activeTopic", "activeSubTopic", "onButtonClick", "onSubTopicButtonClick", "mainTopics", "subTopics", "mainVariant", "subVariant", "mainProps", "subProps"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      paddingBottom: "1rem"
    },
    activeButton: {
      color: theme.palette.text.secondary
    },
    activeSubButton: {},
    mainButton: _defineProperty({
      fontFamily: theme.typography.fontFamily,
      textTransform: "capitalize",
      fontSize: "0.75rem",
      minWidth: "57px",
      padding: "0.5rem",
      "&:hover": {
        color: theme.palette.text.secondary
      }
    }, theme.breakpoints.up("md"), {
      fontSize: "1rem",
      padding: "auto 1rem",
      minWidth: "100px"
    }),
    subButton: _defineProperty({
      fontWeight: 700,
      letterSpacing: 0,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none"
      },
      fontSize: "0.75rem",
      marginRight: theme.typography.pxToRem(16),
      "&:last-of-type": {
        marginRight: 0
      }
    }, theme.breakpoints.up("md"), {
      fontSize: "initial"
    }),
    itemContainer: {
      display: "flex",
      flexDirection: "column"
    },
    filter: _defineProperty({
      display: "flex",
      padding: "1.5rem 0rem",
      flexDirection: "row",
      alignItems: "center",
      flexGrow: 1,
      flexWrap: "wrap"
    }, theme.breakpoints.up("md"), {
      flexGrow: 0,
      padding: 0
    }),
    subtopic: {
      paddingTop: "1rem"
    }
  };
});

function Filter(_ref) {
  var activeTopic = _ref.activeTopic,
      activeSubTopic = _ref.activeSubTopic,
      onButtonClick = _ref.onButtonClick,
      onSubTopicButtonClick = _ref.onSubTopicButtonClick,
      mainTopics = _ref.mainTopics,
      subTopics = _ref.subTopics,
      mainVariant = _ref.mainVariant,
      subVariant = _ref.subVariant,
      mainProps = _ref.mainProps,
      subProps = _ref.subProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    container: true,
    spacing: 2,
    className: classes.filter
  }, mainTopics && mainTopics.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      item: true,
      key: item.slug
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({}, mainProps, {
      variant: mainVariant,
      className: (0, _clsx3["default"])(classes.mainButton, _defineProperty({}, classes.activeButton, item.slug === activeTopic)),
      onClick: function onClick() {
        return onButtonClick(item.slug);
      }
    }), item.name));
  })), subTopics && subTopics.length > 0 && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.subtopic
  }, subTopics.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_core.ButtonBase, _extends({}, subProps, {
      key: item.slug,
      variant: subVariant,
      onClick: function onClick() {
        return onSubTopicButtonClick(item.slug);
      },
      className: (0, _clsx3["default"])(classes.subButton, _defineProperty({}, classes.activeSubButton, item.slug === activeSubTopic))
    }), item.name);
  })));
}

Filter.propTypes = {
  onButtonClick: _propTypes.PropTypes.func,
  onSubTopicButtonClick: _propTypes.PropTypes.func,
  mainTopics: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({})).isRequired,
  subTopics: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({})).isRequired,
  activeTopic: _propTypes.PropTypes.string,
  activeSubTopic: _propTypes.PropTypes.string,
  mainVariant: _propTypes.PropTypes.string,
  subVariant: _propTypes.PropTypes.string,
  mainProps: _propTypes.PropTypes.shape({}),
  subProps: _propTypes.PropTypes.shape({}),
  classes: _propTypes.PropTypes.shape({
    root: _propTypes.PropTypes.string,
    activeButton: _propTypes.PropTypes.string,
    activeSubButton: _propTypes.PropTypes.string,
    mainButton: _propTypes.PropTypes.string,
    subButton: _propTypes.PropTypes.string,
    itemContainer: _propTypes.PropTypes.string,
    filter: _propTypes.PropTypes.string,
    subtopic: _propTypes.PropTypes.string
  })
};
Filter.defaultProps = {
  activeTopic: undefined,
  activeSubTopic: undefined,
  onButtonClick: undefined,
  onSubTopicButtonClick: undefined,
  classes: undefined,
  mainVariant: "contained",
  subVariant: "text",
  mainProps: {},
  subProps: {}
};
var _default = Filter;
exports["default"] = _default;